// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageableObject
 */
export interface IPageableObject {
    /**
     * 
     * @type {number}
     * @memberof IPageableObject
     */
    offset?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageableObject
     */
    paged?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPageableObject
     */
    page_number?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageableObject
     */
    page_size?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageableObject
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {boolean}
     * @memberof IPageableObject
     */
    unpaged?: boolean;
}

/**
 * Check if a given object implements the IPageableObject interface.
 */
export function instanceOfIPageableObject(value: object): value is IPageableObject {
    return true;
}

export function IPageableObjectFromJSON(json: any): IPageableObject {
    return IPageableObjectFromJSONTyped(json, false);
}

export function IPageableObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageableObject {
    if (json == null) {
        return json;
    }
    return {
        
        'offset': json['offset'] == null ? undefined : json['offset'],
        'paged': json['paged'] == null ? undefined : json['paged'],
        'page_number': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'page_size': json['pageSize'] == null ? undefined : json['pageSize'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'unpaged': json['unpaged'] == null ? undefined : json['unpaged'],
    };
}

export function IPageableObjectToJSON(json: any): IPageableObject {
    return IPageableObjectToJSONTyped(json, false);
}

export function IPageableObjectToJSONTyped(value?: IPageableObject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offset': value['offset'],
        'paged': value['paged'],
        'pageNumber': value['page_number'],
        'pageSize': value['page_size'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'unpaged': value['unpaged'],
    };
}

